import { HttpClient } from '@angular/common/http';
import { EventEmitter } from '@angular/core';
import { MatSlider } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from 'app/shared/services/user.service';
import { Subject } from 'rxjs';
var VideoPlayerComponent = (function () {
    function VideoPlayerComponent(document, httpClient, sanitizer, userService) {
        this.document = document;
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.userService = userService;
        this.clientX = 0;
        this.clientY = 0;
        this.getNextExercise = new EventEmitter();
        this.getNewExercise = new EventEmitter();
        this.onVideoEnded = new EventEmitter();
        this.videoProgress = new EventEmitter();
        this.isMuted = VideoPlayerComponent.videoMuted;
        this.seekbarMaxValue = 100;
        this.seekbarProgress = 0;
        this.seekbarThumb = 0;
        this.fullScreened = false;
        this.showOverlay = true;
        this.videoEnded = false;
        this.pausedVideo = true;
        this.captionObjectUrl = '';
        this.captionActive = false;
        this.ngUnsubscribe = new Subject();
    }
    VideoPlayerComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.fetchCaptionFile();
        var i = setInterval(function () {
            if (_this.videoPlayer.nativeElement.readyState > 0) {
                _this.now = _this.videoPlayer.nativeElement.duration - _this.videoPlayer.nativeElement.currentTime;
                clearInterval(i);
            }
        }, 100);
        this.playPause();
        this.volumeSlider.value = VideoPlayerComponent.videoVolume;
        this.videoPlayer.nativeElement.volume = this.volumeSlider.value;
        this.videoPlayer.nativeElement.muted = this.isMuted;
        // Read the user setting for captions and activate or deactivate them on video start
        this.userService.currentUser.takeUntil(this.ngUnsubscribe).subscribe(function (user) {
            var caption = _this.videoPlayer.nativeElement.textTracks[0];
            if (user.enableCaptions) {
                caption.mode = 'showing';
                _this.captionActive = true;
            }
            else {
                caption.mode = 'hidden';
                _this.captionActive = false;
            }
        });
    };
    VideoPlayerComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    VideoPlayerComponent.prototype.isOverlayVisible = function () {
        return this.showOverlay || this.videoEnded || this.pausedVideo;
    };
    VideoPlayerComponent.prototype.playPause = function () {
        if (this.videoPlayer.nativeElement.paused) {
            this.videoPlayer.nativeElement.play();
            this.pausedVideo = false;
            this.showOverlay = false;
            this.videoEnded = false;
        }
        else {
            this.videoPlayer.nativeElement.pause();
            this.pausedVideo = true;
        }
    };
    VideoPlayerComponent.prototype.seekBar = function (event) {
        // Calculate the new time
        var time = this.videoPlayer.nativeElement.duration * (event.target.value / 100);
        // Update the video time
        this.videoPlayer.nativeElement.currentTime = time;
    };
    VideoPlayerComponent.prototype.seekBarUpdate = function () {
        // Calculate the slider value
        var value = (100 / this.videoPlayer.nativeElement.duration) * this.videoPlayer.nativeElement.currentTime;
        // Update the slider value
        this.seekbarProgress = value;
        this.now = this.videoPlayer.nativeElement.duration - this.videoPlayer.nativeElement.currentTime;
        this.videoEnded = false;
        if (this.now === 0) {
            this.videoEnded = true;
            this.pausedVideo = true;
            /**
            * Stop Fullscreen on iPhone when Video ends to display Video Overlay (-Buttons)
            */
            if (window.navigator.userAgent && window.navigator.userAgent.includes('iPhone')) {
                //this.toggleFullScreen();
                this.videoPlayer.nativeElement.webkitExitFullscreen();
            }
            this.onVideoEnded.emit();
        }
        this.videoProgress.emit({
            value: this.videoPlayer.nativeElement.currentTime,
            progress: value,
            total: this.videoPlayer.nativeElement.duration,
        });
    };
    VideoPlayerComponent.prototype.changeUrl = function (videoUrl, captionUrl) {
        this.video = videoUrl;
        this.videoPlayer.nativeElement.src = videoUrl;
        this.captions = captionUrl;
        this.fetchCaptionFile();
        this.playPause();
    };
    VideoPlayerComponent.prototype.mute = function () {
        this.videoPlayer.nativeElement.muted = !this.videoPlayer.nativeElement.muted;
        this.isMuted = VideoPlayerComponent.videoMuted = this.videoPlayer.nativeElement.muted;
        if (this.isMuted) {
            this.volumeSlider.value = 0;
        }
        else {
            this.volumeSlider.value = VideoPlayerComponent.videoVolume;
        }
    };
    VideoPlayerComponent.prototype.volumeBar = function (event) {
        this.videoPlayer.nativeElement.volume = event.value;
        // persist video volume between players
        VideoPlayerComponent.videoVolume = event.value;
        if (event.value > 0 && this.isMuted) {
            this.mute();
        }
    };
    VideoPlayerComponent.prototype.newExercise = function (event) {
        event.stopPropagation();
        this.getNewExercise.emit();
    };
    VideoPlayerComponent.prototype.nextExercise = function (event) {
        event.stopPropagation();
        this.getNextExercise.emit();
    };
    /**
     * Whenever you switch videos without closing the vidoe dialog, it is possible,
     * that the subtitle of the previous video keeps showing up if captions are enabled.
     * Toggling the mode fixes this.
     */
    VideoPlayerComponent.prototype.resetCaption = function () {
        var caption = this.videoPlayer.nativeElement.textTracks[0];
        if (caption.mode === 'showing') {
            caption.mode = 'hidden';
            caption.mode = 'showing';
        }
    };
    VideoPlayerComponent.prototype.toggleCaption = function () {
        if (!this.captionObjectUrl) {
            return;
        }
        var caption = this.videoPlayer.nativeElement.textTracks[0];
        if (caption.mode === 'hidden') {
            caption.mode = 'showing';
            this.captionActive = true;
        }
        else {
            caption.mode = 'hidden';
            this.captionActive = false;
        }
    };
    VideoPlayerComponent.prototype.toggleFullScreen = function () {
        var element = this.vidContainer.nativeElement;
        if (this.fullScreened) {
            if (this.document.cancelFullScreen) {
                this.document.cancelFullScreen();
            }
            else if (this.document.mozCancelFullScreen) {
                this.document.mozCancelFullScreen();
            }
            else if (this.document.webkitCancelFullScreen) {
                this.document.webkitCancelFullScreen();
            }
            else if (this.document.webkitExitFullscreen) {
                this.document.webkitExitFullscreen();
            }
            else if (this.document.msExitFullscreen) {
                this.document.msExitFullscreen();
            }
            else if (this.videoPlayer.nativeElement.webkitExitFullscreen) {
                this.videoPlayer.nativeElement.webkitExitFullscreen();
            }
        }
        else {
            if (element.requestFullScreen) {
                element.requestFullScreen();
            }
            else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            }
            else if (element.webkitRequestFullScreen) {
                element.webkitRequestFullScreen();
            }
            else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            }
            else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
            else if (this.videoPlayer.nativeElement.webkitEnterFullScreen) {
                this.videoPlayer.nativeElement.webkitEnterFullScreen();
            }
        }
    };
    VideoPlayerComponent.prototype.cancelFS = function () { };
    VideoPlayerComponent.prototype.fetchCaptionFile = function () {
        var _this = this;
        this.httpClient.get(this.captions, { headers: { 'access-control-allow-origin': '*' }, responseType: 'blob' }).subscribe(function (content) {
            if (content) {
                if (_this.captionObjectUrl) {
                    window.URL.revokeObjectURL(_this.captionObjectUrl.toString());
                }
                _this.captionObjectUrl = _this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(content));
                _this.resetCaption();
            }
        });
    };
    VideoPlayerComponent.prototype.keyEvent = function (event) {
        this.fullScreened =
            document.fullscreen ||
                document.mozFullScreen ||
                document.webkitIsFullScreen ||
                document.msFullscreenElement ||
                document.webkitDisplayingFullscreen;
    };
    VideoPlayerComponent.prototype.mouseOver = function (event) {
        var _this = this;
        if (this.mouseOverTimer) {
            clearTimeout(this.mouseOverTimer);
        }
        this.showOverlay = true;
        this.mouseOverTimer = setTimeout(function () {
            _this.showOverlay = false;
        }, 2000);
    };
    VideoPlayerComponent.prototype.mouseOut = function (event) {
        var _this = this;
        if (this.mouseOverTimer) {
            clearTimeout(this.mouseOverTimer);
        }
        this.showOverlay = true;
        this.mouseOverTimer = setTimeout(function () {
            _this.showOverlay = false;
        }, 500);
    };
    VideoPlayerComponent.videoVolume = 0.5;
    VideoPlayerComponent.videoMuted = false;
    return VideoPlayerComponent;
}());
export { VideoPlayerComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/video-player/video-player.component.ts.pre-build-optimizer.js